<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const year = new Date().getFullYear();
</script>

<template>
    <span>{{ tt('copyright', { year }) }}</span>
</template>
